const LIQUID_3D_ITEM_NUMBERS = new Set([
  '_LIQUID_3D',
  '_ARTPROOF_L3D_US',
]);

export const isLiquid3DItemNumber = (value: unknown): boolean =>
  typeof value === 'string' && LIQUID_3D_ITEM_NUMBERS.has(value);

export const isLiquid3DArtProofItemNumber = (value: unknown): boolean =>
  value === '_ARTPROOF_L3D_US';
